/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Newer_Version_DescInputs */

const en_ui_newer_version_desc = /** @type {(inputs: Ui_Newer_Version_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another tab runs a newer version. Reload to keep your data in sync.`)
};

const de_ui_newer_version_desc = /** @type {(inputs: Ui_Newer_Version_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein anderer Tab nutzt schon eine neuere Version. Lade neu, damit deine Daten synchron bleiben.`)
};

/**
* | output |
* | --- |
* | "Another tab runs a newer version. Reload to keep your data in sync." |
*
* @param {Ui_Newer_Version_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_newer_version_desc = /** @type {((inputs?: Ui_Newer_Version_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Newer_Version_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_newer_version_desc(inputs)
	return de_ui_newer_version_desc(inputs)
});